module.exports = __webpack_public_path__ + "static/media/close_icon_red.bf695547.svg";